import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { LegalFooter } from "@/components/LegalFooter";

interface StandaloneLayoutProps {
  children?: ReactNode;
  /** Hide the trust footer (e.g. on terminal screens). */
  hideFooter?: boolean;
}

function LockIcon() {
  return (
    <svg
      className="h-3 w-3 shrink-0"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

/** Full-page chrome for standalone mode: minimal branding + trust footer. */
export function StandaloneLayout({ children, hideFooter }: StandaloneLayoutProps) {
  const content = children ?? <Outlet />;
  return (
    <div className="r1-intake-root flex min-h-screen flex-col bg-white">
      <header className="border-b border-slate-100">
        <div className="mx-auto flex w-full max-w-3xl items-center justify-between px-5 py-4">
          <Brand />
          <span className="flex items-center gap-1 text-xs text-ink-muted">
            <LockIcon />
            Secure intake
          </span>
        </div>
      </header>

      <main className="flex flex-1 flex-col">{content}</main>

      {!hideFooter ? (
        <footer className="border-t border-slate-100">
          <LegalFooter className="mx-auto w-full max-w-3xl px-5 py-5 text-xs text-ink-muted" />
        </footer>
      ) : null}
    </div>
  );
}
